<template>
  <div class="videoBox">
    <el-dialog
      :visible.sync="dialogFormVisible"
      :showClose="showClose"
      :close-on-click-modal="showClose"
      :close-on-press-escape="showClose"
    >
      <div @click="handleClose" class="closeBtn">
        <i class="el-icon-close"></i>
      </div>
      <!-- <video
        :src="videos"
        autoplay="autoplay"
        :poster="videoImg"
        controls="controls"
        class="divVideo"
        id="video1"
      >
        您的浏览器不支持 video 标签。
      </video> -->
      <!-- <video-player  class="video-player-box"
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="true"
          customEventName="customstatechangedeventname"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
          @ended="onPlayerEnded($event)"
          @waiting="onPlayerWaiting($event)"
          @playing="onPlayerPlaying($event)"
          @loadeddata="onPlayerLoadeddata($event)"
          @timeupdate="onPlayerTimeupdate($event)"
          @canplay="onPlayerCanplay($event)"
          @canplaythrough="onPlayerCanplaythrough($event)"
          @statechanged="playerStateChanged($event)"
          @ready="playerReadied">
      </video-player> -->
      <d-player
        v-if="play"
        ref="player"
        id="player"
        :options="options"
      ></d-player>
    </el-dialog>
  </div>
</template>
<script>
import dPlayer from "./dplayer";
import "./dplayer/dist/vue-dplayer.css";
export default {
  name: "items",
  props: {},
  data() {
    return {
      dialogFormVisible: false,
      videoImg: "",
      videos: "",
      showClose: false,
      player: null,
      play: true,
      options: {
        autoplay: true, //自动播放
        loop: false,
        lang: "zh-cn",
        video: {
          url: "",
          pic: "",
        },
        contextmenu: [{}],
      },
      // playerOptions: {
      //   height: 400,
      //   playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
      //   autoplay: false, // 如果true,浏览器准备好时开始回放。
      //   muted: false, // 默认情况下将会消除任何音频。
      //   loop: false, // 导致视频一结束就重新开始。
      //   preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      //   language: "zh-CN",
      //   aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      //   fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      //   sources: [
      //     {
      //       type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
      //       src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm" // url地址
      //     }
      //   ],
      //   poster: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fyouimg1.c-ctrip.com%2Ftarget%2Ftg%2F004%2F531%2F381%2F4339f96900344574a0c8ca272a7b8f27.jpg&refer=http%3A%2F%2Fyouimg1.c-ctrip.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1624785380&t=40e841405578eeabd40415caa0c22475", // 你的封面地址
      //   // width: document.documentElement.clientWidth, //播放器宽度
      //   notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
      //   controlBar: {
      //     timeDivider: true,
      //     durationDisplay: true,
      //     remainingTimeDisplay: true,
      //     fullscreenToggle: true // 全屏按钮
      //   }
      // },
    };
  },
  computed: {},
  components: {
    dPlayer
  },
  methods: {
    // 弹层显示
    dialogFormV(data) {
      this.play = true;
      this.dialogFormVisible = true;
      // this.$refs.videoPlayer.player
      this.options.video.url = data.url || data.pVideoUrl;
      this.options.video.pic = data.videologoImage;

      // this.player.switchVideo({
      //   url: data.url || data.pVideoUrl
      // })
      // this.videoImg = data.videologoImage;
      // if (data.url !== undefined) {
      //   this.videos = data.url;
      // } else {
      //   this.videos = data.pVideoUrl;
      // }
    },
    // 弹层隐藏
    dialogFormH() {
      this.dialogFormVisible = false;
    },

    // 退出
    handleClose() {
      this.play = false;
      this.dialogFormVisible = false;
    },
  },
  // 挂载结束
  mounted: function () {
    this.player = this.$refs.player ? this.$refs.player.dp : null;
  },
  // 创建完毕状态
  created() {
    if (this._setVideoUrl) {
      this._setVideoUrl(this.source);
    }
  },
  // 组件更新
  updated: function () {},
};
</script>
<style></style>
<style lang="scss">
.videoBox {
  .el-dialog__header,
  .el-dialog {
    background: transparent;
    box-shadow: none;
  }
  .el-icon-close {
    font-size: 30px;
    cursor: pointer;
  }
}
.el-dialog__body {
  height: 100%;
  position: relative;
}
</style>
<style lang="scss">
.videoBox {
  .divVideo {
    width: 100%;
    max-height: 850px;
  }
}
</style>
